import type { PlannerHandoff } from '../planner-handoff';

/**
 * "From your Planner" on home: the standards a Planner item was tagged with, and its link for
 * reference (R8, KTD5). Collab checks an uploaded file, not a link, so the banner says how to
 * check the lesson: upload it to a group and run the Standards check there.
 *
 * Dismissing it drops the hand-off for this tab — the banner and the check's expected
 * standards are one thing, so closing one closes both.
 */
export default function PlannerBanner({ handoff, onDismiss }: { handoff: PlannerHandoff; onDismiss: () => void }) {
  const titleId = 'planner-banner-title';
  return (
    <section className="panel notice planner-banner ph-no-capture" data-ph-no-capture aria-labelledby={titleId}>
      <h2 id={titleId}>From your Planner</h2>
      <p>
        Expected standards:{' '}
        {handoff.expected.map((standard, i) => (
          <span key={standard.id}>{i > 0 && ', '}<strong>{standard.code}</strong></span>
        ))}
      </p>
      {handoff.link && (
        <p>
          <a className="link" href={handoff.link} target="_blank" rel="noopener noreferrer">Open the lesson link</a>
          {' '}<span className="hint">(for reference — Collab checks an uploaded file)</span>
        </p>
      )}
      <p className="hint">
        Upload the lesson to a group and run its Standards check. The results will mark which of these standards it covers.
      </p>
      <button type="button" className="secondary" onClick={onDismiss}>Dismiss</button>
    </section>
  );
}
